<template>
  <section class="listing">
    <div class="header">
      <div class="title">Clientes</div>
    </div>

    <!--<form @submit.prevent class="form form-search">

    </form>-->

    <form @submit.prevent="getData" class="form form-search">
      <input v-model="iniDate" @change="getData" type="date" />
      <input v-model="endDate" @change="getData" type="date" />
      <input v-model="search" type="text" placeholder="Assinante..." />
      <!--<div class="form-inputs">
        <div class="form-inputs-line">
          <input v-model="iniDate" @change="getData" type="date" />
          <input v-model="endDate" @change="getData" type="date" />
        </div>
        <div class="form-inputs-line">
          <select v-model="fonte">
            <option :value="null" disabled selected>Fonte do Assinante</option>
            <option value="">TODOS</option>
            <option value="TERCIO">TERCIO</option>
            <option value="REGIS">REGIS</option>
            <option value="QE">QE</option>
            <option value="ANDERSON">ANDERSON</option>
            <option value="EMANUEL">EMANUEL</option>
            <option value="SWISS">SWISS</option>
          </select>
        </div>
      </div>-->
      <div>
        <button type="submit" class="btn-search">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </form>

    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading" style="margin-top: 10px">
        <div class="sum-group">
          <div class="sum">
            <span>Clientes</span>
            <span>{{ customers.length.toLocaleString('pt-br') }}</span>
          </div>
          <div class="sum">
            <span>Valor Total</span>
            <span>{{ total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</span>
          </div>
        </div>
        <div v-for="(c, i) in customers" :key="i" class="list">
          <div v-if="i > 0 ? getDay(c.date) !== getDay(customers[i - 1].date) : true" class="calendar">
            <span>{{ getDay(c.date) }}</span>
            <span>{{ getMonthText(c.date) }}</span>
          </div>
          <div v-if="i > 0 ? getDay(c.date) === getDay(customers[i - 1].date) : false" style="width: 50px"></div>
          <div class="data">
            <div class="main-data">{{ c.name }}</div>
            <div class="detail-data">{{ c.login }}</div>
          </div>
          <div style="text-align: right;margin-right: 20px;">
            <div class="main-data">{{ (c.amount || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</div>
            <!-- <div class="detail-data">{{ c.tickets }} produto(s)</div> -->
          </div>
          <div class="actions">
            <!-- <button  @click="remove(p.id)" class="button-action" style="margin-right: 5px"><i class="fas fa-trash-alt"></i><span>EXCLUIR</span></button> -->
            <button @click="$router.push(`/customer/${c.id}`)" class="button-action"><i class="fas fa-eye"></i><span>VISUALIZAR</span></button>
          </div>
        </div>
      </div>
    </transition>
    <Customer v-if="customer" :id="customer" :customerData="customerData" />
  </section>
</template>

<script>
import logger from '../../logger'
import { getAll } from '../api/customer'
import Customer from './Customer.vue'

export default {
  name: 'customers',
  components: { Customer },
  props: ['id'],
  data () {
    return {
      loading: true,
      customers: [],
      customer: null,
      customerData: null,
      iniDate: null,
      endDate: null,
      fonte: null,
      search: ''
    }
  },
  watch: {
    async '$route' (value) {
      this.customer = value.params['id'] || null
      // Update list
      if (!value.params['id']) {
        this.getData()
      } else {
        this.customerData = this.customers.find(x => x.id === Number(value.params['id']))
      }
    }
  },
  computed: {
    total () {
      return this.customers.map(x => Number(x.amount)).reduce((acc, cur) => acc + cur, 0)
    },
    filtered () {
      return this.customers.filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    }
  },
  async mounted () {
    try {
      /* const date = new Date()
      this.endDate = date.toISOString().split('T')[0]
      date.setMonth(date.getMonth() - 6)
      this.iniDate = date.toISOString().split('T')[0]
      this.getData() */

      const dateIni = new Date()
      const dateFim = new Date()
      dateFim.setMonth(dateFim.getMonth() + 1)
      dateFim.setDate(1)
      dateFim.setDate(dateFim.getDate() - 1)
      this.endDate = dateFim.toISOString().split('T')[0]

      dateIni.setDate(1)
      // date.setDate(date.getDate() - 90)
      this.iniDate = dateIni.toISOString().split('T')[0]
      this.getData()
    } catch (error) {
      logger.error(error)
    }
  },
  methods: {
    async getData () {
      this.loading = true
      try {
        const customers = await getAll(this.iniDate, this.endDate)
        console.log(this.search)
        if (this.search) {
          this.customers = customers.filter(x => String(x.name).toUpperCase().includes(this.search.toUpperCase()))
        } else {
          this.customers = customers || []
        }
      } catch (error) {
        logger.error(error)
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
.list {
  border: 1px solid #918f8f;
}
.calendar {
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  border-radius: 5px;
  margin-right: 10px;
  font-weight: 500;
  span:nth-child(1) {
    font-size: 1.2em;
  }
  span:nth-child(2) {
    font-size: 0.7em;
  }
}

.time-text {
  font-size: 2.2em;
  font-weight: 400;
  margin-right: 10px;
  color: #555;
  display: flex;
  span:nth-child(2) {
    font-size: 0.5em;
    line-height: 2em;
  }
}

.form-search {
  display: flex;
  flex-direction: row;
  padding: 0;
  padding-bottom: 10px;

  input {
    flex: 1;
    margin: 0 5px;
  }
}

.button-action:hover {
  i {
    animation-name: ticket-image !important;
    animation-duration: 0.5s !important;
    animation-iteration-count: 1 !important;
  }
}

.form-search {
  flex-direction: row;
  align-items: center;
  padding: 0;
  padding-bottom: 10px;

  .form-inputs {
    width: calc(100% - 45px);
  }

  .form-inputs-line {
    display: flex;
    flex-wrap: wrap;
  }

  input, select {
    flex-grow: 1;
    margin: 5px;
  }
}

.btn-search {
  flex-shrink: 0;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  width: 39px;
  height: 39px;
  color: #fff;
  border-radius: 50%;
  border: 1px solid $primary-color;
  cursor: pointer;
  font-size: 1.1em;
  margin-left: 5px;
  &:focus {
    outline: 0;
  }
}

.sum-group {
  display: flex;
  flex-wrap: wrap;
  .sum {
    display: flex;
    flex-basis: calc(100% - 10px);
    margin: 0 5px 10px;
    span {
      text-align: center;
      padding: 8px 0;
      flex-basis: 50%;
    }
    span:nth-child(1) {
      color: #fff;
      background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
      border-radius: 5px 0 0 5px;
      border: 1px solid $secondary-color;
    }
    span:nth-child(2) {
      font-weight: bold;
      color: $secondary-color;
      border-radius: 0 5px 5px 0;
      border: 1px solid $secondary-color;
    }
  }
}

// Desktop
@media screen and (min-width: $desktop-width) {
  .sum-group {
    .sum {
      flex-basis: calc(50% - 10px);
    }
  }
}
</style>
